import { useSelector } from 'react-redux';
import { allowAdmin } from '@/roles/helper';

const useAdminLauncherMenu = () => useSelector(({
  auth: { role: { permissions } },
  collections: { newCollectionCode },
  userGroups: { newUserGroupCode },
}) => ({
  allowThemes: permissions.themes.update,
  allowVocabularies: permissions.vocabularies.update,
  allowRoles: permissions.roles.read,
  allowNewRoles: permissions.roles.create,
  allowUsers: permissions.users.read,
  allowTokens: permissions.tokens.read,
  allowNewCollections: permissions.collections.create,
  allowCollections: permissions.datasets.read,
  allowUserGroups: permissions.usergroups.read,
  allowNewUserGroup: permissions.usergroups.create,
  newCollectionCode,
  newUserGroupCode,
}));

const useFairLaunchers = () => {
  const { role: { approved, permissions } } = useSelector(({ auth }) => auth);
  return {
    accessActivities: permissions.activities.read,
    accessAdmin: allowAdmin(permissions),
    accessAudit: permissions.audit.read,
    accessCohorts: permissions.cohorts.read,
    accessDatasets: permissions.datasets.read,
    accessRequests: permissions.requests.read || permissions.tasks.read,
    accessSearch: permissions.search.run && permissions.datasets.read,
    approved,
  };
};

export default {
  useAdminLauncherMenu,
  useFairLaunchers,
};
